const api_url =
  'https://800vfx6s4a.execute-api.us-east-1.amazonaws.com/dev/api'
const file_url = 'https://api.testigram.ai'
const commentLimit = 300
const max_file_size = 10 * 1000 * 1000
const GA_TRACKING_ID = 'G-J5CP5MSP3R'

export { api_url, commentLimit, file_url, max_file_size, GA_TRACKING_ID }
